import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions,
	createResourceMutationDefinitions,
	updateResourceMutationDefinitions,
	deleteResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

export const SCENARIO_CREATE_MUTATION = gql`
	mutation CreateScenario($input: CreateScenarioInput!) {
		createScenario(input: $input) {
			success
			errorCode
			errorDescription
		}
	}
`;

export const SCENARIOS_LIST_QUERY = gql`
	query Scenarios($first: Int, $after: String) {
		scenarios(first: $first, after: $after) {
			nodes {
				scenarioId
				name
				scenarioConditions {
					conditionId
					condition {
						conditionId
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

// Lookup queries for scenario create/edit
export const VEHICLE_TYPES_QUERY = gql`
	query VehicleTypes {
		vehicleTypes {
			vehicleTypeId
			name
			rateMultiplier
		}
	}
`;

export const CUSTOMER_CATEGORIES_QUERY = gql`
	query CustomerCategories {
		customerCategories {
			customerCategoryId
			code
			description
			simultaneousVehicleLimit
		}
	}
`;

export const WEEKLY_DATE_SETS_QUERY = gql`
	query WeeklyDateSets {
		weeklyDateSets {
			weeklyDateSetId
			name
		}
	}
`;

export const PAYMENT_METHODS_QUERY = gql`
	query PaymentMethods {
		paymentMethods {
			paymentMethodId
			name
		}
	}
`;

export const CONDITIONS_LIST_QUERY = gql`
	query Conditions {
		conditions(first: 50) {
			nodes {
				conditionId
				startDate
				endDate
				arrivingSince
				arrivingUntil
				leavingSince
				leavingUntil
				weeklyDateSetId
				appliesOnHolidays
				minStayMinutes
				maxStayMinutes
				appliesToSpecificVehicleTypes
				appliesToSpecificCustomerCategories
				isOverstay
				isContractOverstay
				weeklyDateSet {
					weeklyDateSetId
					name
				}
				conditionVehicleTypes {
					vehicleTypeId
					vehicleType {
						vehicleTypeId
						name
					}
				}
				conditionCustomerCategories {
					customerCategoryId
					customerCategory {
						customerCategoryId
						description
					}
				}
				conditionDayOfWeeks {
					dayOfWeekId
					dayOfWeek {
						dayOfWeekId
						name
					}
				}
				appliesToSpecificPaymentMethods
				conditionPaymentMethods {
					paymentMethodId
					paymentMethod {
						paymentMethodId
						name
					}
				}
			}
		}
	}
`;

export const SCENARIO_LIST_ITEM_QUERY = gql`
	query ScenarioListItem($id: Ulid!) {
		scenario(id: $id) {
			scenarioId
			name
			scenarioConditions {
				conditionId
				condition {
					conditionId
				}
			}
		}
	}
`;

export const SCENARIO_QUERY = gql`
	query Scenario($id: Ulid!) {
		scenario(id: $id) {
			scenarioId
			name
			scenarioConditions {
				conditionId
				condition {
					conditionId
					startDate
					endDate
					arrivingSince
					arrivingUntil
					leavingSince
					leavingUntil
					weeklyDateSetId
					appliesOnHolidays
					minStayMinutes
					maxStayMinutes
					appliesToSpecificVehicleTypes
					appliesToSpecificCustomerCategories
					isOverstay
					isContractOverstay
					weeklyDateSet {
						name
					}
					conditionVehicleTypes {
						vehicleTypeId
						vehicleType {
							name
						}
					}
					conditionCustomerCategories {
						customerCategoryId
						customerCategory {
							description
						}
					}
					conditionDayOfWeeks {
						dayOfWeekId
						dayOfWeek {
							name
						}
					}
					appliesToSpecificPaymentMethods
					conditionPaymentMethods {
						paymentMethodId
						paymentMethod {
							paymentMethodId
							name
						}
					}
				}
			}
		}
	}
`;

export const SCENARIO_UPDATE_MUTATION = gql`
	mutation UpdateScenario($input: UpdateScenarioInput!) {
		updateScenario(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const SCENARIO_DELETE_MUTATION = gql`
	mutation DeleteScenario($input: DeleteScenarioInput!) {
		deleteScenario(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['scenarios'] = {
	document: SCENARIOS_LIST_QUERY,
	dataPath: 'scenarios'
};

viewResourceQueryDefinitions['scenarios'] = {
	document: SCENARIO_QUERY,
	dataPath: 'scenario'
};

createResourceMutationDefinitions['scenarios'] = {
	document: SCENARIO_CREATE_MUTATION,
	operation: 'createScenario',
	getVariables: variables => ({ input: variables })
};

updateResourceMutationDefinitions['scenarios'] = {
	document: SCENARIO_UPDATE_MUTATION,
	operation: 'updateScenario',
	getVariables: variables => ({ input: variables })
};

deleteResourceMutationDefinitions['scenarios'] = {
	document: SCENARIO_DELETE_MUTATION,
	operation: 'deleteScenario',
	getVariables: variables => ({ input: variables })
};
